<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.question"
              label="问题"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.questionErrors.length"
              :error-messages="error.questionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.answer"
              label="回答"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.answerErrors.length"
              :error-messages="error.answerErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>

        <div class='flex md2 offset--md5'>
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>

      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '../../utils/common'
import commonQuestionApi from '../../api/commonQuestion'

export default {
  data () {
    return {
      insertData: {
        id: null,
        question: '',
        answer: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        questionErrors: [],
        answerErrors: [],
        sortNumErrors: [],
      },
      title: '新增常见问题',
      showId: false,
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑常见问题'
      // 通过id获取详情
      commonQuestionApi.getCommonQuestion(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.answerErrors.length &&
          !this.error.questionErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        answer: this.insertData.answer,
        question: this.insertData.question,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        commonQuestionApi.updateCommonQuestion(this.insertData.id, data).then(response => {
          this.$router.push({ name: 'listCommonQuestion' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        commonQuestionApi.saveCommonQuestion(data).then(response => {
          this.$router.push({ name: 'listCommonQuestion' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error.msg)
        })
      }
    },
    checkField () {
      this.error.questionErrors = this.insertData.question ? [] : ['question is required']
      this.error.answerErrors = this.insertData.answer ? [] : ['answer is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },

  },
}

</script>
